exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inspiration>div[data-v-cdf9b47a]{display:grid;grid-gap:30px;grid-template-columns:repeat(5,1fr) 50px;padding-right:40px;position:relative\n}\n.inspiration>div button[data-v-cdf9b47a]{top:40px\n}\n.add-another[data-v-cdf9b47a]{display:grid;grid-gap:30px;grid-template-columns:1fr 1fr 100px\n}\n.add-another .button[data-v-cdf9b47a],.add-another select[data-v-cdf9b47a]{margin:0\n}", ""]);

// exports
